import React from 'react';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';
import { Button } from '@/components/ui/button';
import { FileBarChart, Download, Eye, Calendar, User } from 'lucide-react';

const reports = [
  { id: "1", title: "Informe Mensual - Depto Vitacura", owner: "Carlos Guzmán", date: "2025-12-01", views: 45, inquiries: 12 },
  { id: "2", title: "Informe Semanal - Casa Las Condes", owner: "Elena Rivas", date: "2025-12-24", views: 128, inquiries: 24 },
  { id: "3", title: "Resumen Trimestral - Oficinas Providencia", owner: "Inversiones Delta", date: "2025-11-15", views: 312, inquiries: 56 }
];

export function CRMReportsPage() {
  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-4xl font-display font-black uppercase text-ink italic">Informes a Propietarios</h1>
            <p className="text-serif italic text-ink/60 mt-2">Envía reportes de actividad y performance a tus clientes.</p>
          </div>
          <Button className="h-14 px-8 gap-2">
            <FileBarChart className="h-5 w-5" />
            GENERAR NUEVO
          </Button>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {reports.map((report) => (
            <div key={report.id} className="brutalist-border bg-parchment p-8 flex flex-col lg:flex-row justify-between items-center gap-8 group hover:bg-ink hover:text-parchment transition-colors">
              <div className="flex items-center gap-8 w-full lg:w-auto">
                <div className="w-16 h-16 bg-moss flex items-center justify-center text-parchment group-hover:bg-terracotta transition-colors">
                  <FileBarChart className="h-8 w-8" />
                </div>
                <div>
                  <h3 className="text-xl font-display font-black uppercase italic mb-2">{report.title}</h3>
                  <div className="flex flex-wrap gap-6 text-sm font-serif italic opacity-60">
                    <span className="flex items-center gap-2"><User className="h-4 w-4" /> {report.owner}</span>
                    <span className="flex items-center gap-2"><Calendar className="h-4 w-4" /> {report.date}</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-12 w-full lg:w-auto justify-between lg:justify-end border-t lg:border-t-0 pt-6 lg:pt-0 border-ink/10 group-hover:border-parchment/10">
                <div className="flex gap-8">
                  <div className="text-center">
                    <p className="text-[10px] font-black uppercase tracking-widest opacity-40 mb-1">Vistas</p>
                    <p className="text-xl font-display font-black">{report.views}</p>
                  </div>
                  <div className="text-center">
                    <p className="text-[10px] font-black uppercase tracking-widest opacity-40 mb-1">Consultas</p>
                    <p className="text-xl font-display font-black text-terracotta">{report.inquiries}</p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <button className="w-12 h-12 brutalist-border border-ink/20 group-hover:border-parchment/20 flex items-center justify-center hover:bg-terracotta transition-colors">
                    <Eye className="h-5 w-5" />
                  </button>
                  <button className="w-12 h-12 brutalist-border border-ink/20 group-hover:border-parchment/20 flex items-center justify-center hover:bg-moss transition-colors">
                    <Download className="h-5 w-5" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
